import enigma from 'enigma.js';
const qixSchema = require('./node_modules/enigma.js/schemas/qix/3.1/schema.json');

const config = {
  schema: qixSchema,
  session: {
    host: 'sense-demo.qlik.com',
		prefix: '',
		port: 443,
		unsecure: false
  }
};

export default enigma.getService('qix', config).then((qix) => {
  return qix.global.openApp('133dab5d-8f56-4d40-b3e0-a6b401391bde').then((app) => {
    window.app = app;
    return app;
  });
});


// WEBPACK FOOTER //
// ./qApp.js